import storeConfig from 'Stores/carpartguys/config.js';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
}
